import {
    CalendarOutline,
    CaretRightOutline,
    CheckCircleTwoTone,
    ExclamationCircleOutline,
    FormOutline,
    LinkOutline,
    LoadingOutline,
    LoginOutline,
    LogoutOutline,
    MenuFoldOutline,
    MenuUnfoldOutline,
    PlusOutline,
    SettingOutline,
    StarOutline,
    TeamOutline,
    UnorderedListOutline,
    UserOutline,
} from "@ant-design/icons-angular/icons";

export const icons = [
    CalendarOutline,
    CaretRightOutline,
    CheckCircleTwoTone,
    ExclamationCircleOutline,
    FormOutline,
    LinkOutline,
    LoadingOutline,
    LoginOutline,
    LogoutOutline,
    MenuFoldOutline,
    MenuUnfoldOutline,
    PlusOutline,
    SettingOutline,
    StarOutline,
    TeamOutline,
    UnorderedListOutline,
    UserOutline,
];
